export const INIT_AUTH = 'INIT_AUTH'
export const CHANGED_LOCATION = 'CHANGED_LOCATION'
export const CLEAR_ACCESS_TOKEN = 'CLEAR_ACCESS_TOKEN'
export const DONE_INITIALISING = 'DONE_INITIALISING'
export const LOAD_ACCESS_TOKEN_REQUEST = 'LOAD_ACCESS_TOKEN_REQUEST'
export const LOAD_ACCESS_TOKEN_SUCCESS = 'LOAD_ACCESS_TOKEN_SUCCESS'
export const LOAD_ACCESS_TOKEN_FAILURE = 'LOAD_ACCESS_TOKEN_FAILURE'
export const SET_ADMIN_DISCOVERY_SET_ID = 'SET_ADMIN_DISCOVERY_SET_ID'
export const CREATE_ANONYMOUS_INVITE_DATA_REQUEST = 'CREATE_ANONYMOUS_INVITE_DATA_REQUEST'
export const CREATE_ANONYMOUS_INVITE_DATA_SUCCESS = 'CREATE_ANONYMOUS_INVITE_DATA_SUCCESS'
export const CREATE_ANONYMOUS_INVITE_DATA_FAILURE = 'CREATE_ANONYMOUS_INVITE_DATA_FAILURE'
export const SET_ANONYMOUS_INVITE_ID = 'SET_ANONYMOUS_INVITE_ID'
export const SET_ANONYMOUS_FIRM_AND_ADVISER = 'SET_ANONYMOUS_FIRM_AND_ADVISER'



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/modules/constants.js
 **/